import { useEffect, useState } from 'react';
import { portalOrigin, portalUrls } from '@/config';
import { loginUrlWithReturn } from '@/lib/checkout';
import { readStoredToken } from '@/lib/auth-storage';

/**
 * Legacy Stripe returns sometimes still hit POA /?payment=success&session_id=…
 * Forward those straight into the app dashboard confirm flow — never keep buyers on POA.
 */
export default function PaymentReturnBanner() {
  const [status, setStatus] = useState('idle'); // idle | redirecting | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payment = params.get('payment');
    const sessionId = params.get('session_id');

    if (payment !== 'success' || !sessionId) {
      return undefined;
    }

    setStatus('redirecting');
    setMessage('Payment received — opening your dashboard…');

    const appReturn = new URL(`${portalOrigin}/settings`);
    appReturn.searchParams.set('payment', 'success');
    appReturn.searchParams.set('session_id', sessionId);
    appReturn.searchParams.set('noredirect', '1');
    appReturn.searchParams.set('from', 'checkout');

    window.location.replace(appReturn.toString());
    return undefined;
  }, []);

  if (status === 'idle') {
    return null;
  }

  const tone =
    status === 'error'
      ? 'border-red-500/40 bg-red-500/15 text-red-100'
      : 'border-white/15 bg-white/10 text-white';

  return (
    <div className={`fixed inset-x-0 top-0 z-[80] border-b px-4 py-3 backdrop-blur-md ${tone}`}>
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-2 sm:flex-row">
        <p className="text-center text-sm font-medium sm:text-left">{message}</p>
        <div className="flex flex-wrap items-center gap-2">
          {status === 'error' && !readStoredToken() && (
            <a
              href={loginUrlWithReturn()}
              className="inline-flex items-center rounded-lg border border-white/20 px-4 py-2 text-xs font-black uppercase tracking-wide text-white hover:bg-white/10"
            >
              Sign in
            </a>
          )}
          <a
            href={portalUrls.dashboard}
            className="inline-flex items-center rounded-lg bg-[#F04632] px-4 py-2 text-xs font-black uppercase tracking-wide text-white hover:bg-[#D93D2A]"
          >
            Open dashboard →
          </a>
        </div>
      </div>
    </div>
  );
}
